<div class="py-4 container-fluid subject-management-create-page">
  <h4 class="mb-4 subject-management-create-title">การจัดการรายวิชา</h4>

  <div class="subject-management-create-card">
    <div class="subject-management-create-card-body">
      <div class="subject-management-details-loading" *ngIf="loading">กำลังโหลดข้อมูลรายวิชา...</div>
      <div class="subject-management-details-alert" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="subject-management-details-subject-summary">
        <app-subject-info-form
          [subjectForm]="subjectForm"
          [isSaved]="true"
          [allowDelete]="false"
          [subjectApprovalStatusLabel]="subject?.statusLabel ?? null"
          [subjectApprovalStatus]="subject?.status ?? null"
          [academicTermOptions]="academicTermOptions"
          [yearOptions]="yearOptions"
          [subjectTypeOptions]="subjectTypeOptions"
          [subjectOptions]="subjectOptions"
        ></app-subject-info-form>
      </div>

      <div class="subject-management-create-section-area" *ngIf="!loading">
        <div class="subject-management-details-alert" *ngIf="addSectionErrorMessage">{{ addSectionErrorMessage }}</div>

        <div class="subject-management-create-section-toolbar" *ngIf="!isSubjectManagementViewOnly">
          <button type="button" class="app-button app-button-primary subject-management-create-add-section-button"
            [disabled]="isSavingNewSection" (click)="onAddSection()">
            <img src="assets/media/icons/svg/add-item.svg" alt="" aria-hidden="true" />
            <span>เพิ่ม Section</span>
          </button>
        </div>

        <div class="subject-management-create-empty" *ngIf="sectionForms.length === 0">
          ไม่พบข้อมูล Section ของรายวิชานี้
        </div>

        <app-section-editor
          *ngFor="let section of sectionForms; let i = index"
          [section]="section"
          [sectionIndex]="i"
          [teachingTypeOptions]="teachingTypeOptions"
          [teachingDayOptions]="teachingDayOptions"
          [timeOptions]="timeOptions"
          [teachers]="getSectionTeachersAt(i)"
          [workloadMode]="getSectionWorkloadModeAt(i)"
          [isProjectResearch]="isProjectResearchSectionAt(i)"
          [locked]="false"
          [submitted]="isSectionSubmittedAt(i)"
          [editable]="isSectionEditableAt(i)"
          [removable]="isNewSectionAt(i)"
          [showStatus]="!isNewSectionAt(i)"
          [teacherManagementEnabled]="isSectionEditableAt(i)"
          [sectionFieldsEditable]="isSectionFieldsEditableAt(i)"
          [workloadHoursEditable]="false"
          [existingTeachingTimesEditable]="true"
          [editableTeachingTimeStartIndex]="getExistingTeachingTimeCountAt(i)"
          [respectLockedTeachingTimes]="false"
          [canAddTeachingTime]="isSectionEditableAt(i)"
          [usedTeachingTimeIndexes]="getUsedTeachingTimeIndexesAt(i)"
          [projectTeacherEditability]="getProjectTeacherEditabilityAt(i)"
          [collapsible]="!isNewSectionAt(i)"
          [expanded]="isSectionExpandedAt(i)"
          [statusLabel]="getSectionStatusLabelAt(i)"
          [status]="getSectionStatusAt(i)"
          [approvalReady]="!isNewSectionAt(i)"
          [saveMode]="isNewSectionAt(i)"
          [isSubmittingApproval]="isSubmittingApproval || isSavingNewSection"
          (expandedChange)="onSectionExpandedChange(i, $event)"
          (addTeachingTime)="onAddTeachingTimeByIndex(i)"
          (removeTeachingTime)="onRemoveTeachingTimeByIndex(i, $event)"
          (manageTeachers)="onManageTeachersByIndex(i)"
          (editProjectTeacher)="onEditProjectTeacher(i, $event)"
          (removeProjectTeacher)="onRemoveProjectTeacher(i, $event)"
          (submitApproval)="onSubmitApprovalByIndex(i)"
          (saveSection)="onSaveNewSectionByIndex(i)"
          (requestRemove)="onDiscardNewSection(i)"
        ></app-section-editor>
      </div>
    </div>
  </div>
</div>

<app-confirm-dialog
  #submitApprovalConfirmDialog
  modalId="subjectManagementDetailsSubmitApprovalConfirmDialog"
  title="ยืนยันการส่งขอรับรอง"
  message="โปรดตรวจสอบข้อมูลก่อนส่งขอรับรอง ต้องการดำเนินการต่อหรือไม่ ?"
  cancelText="ยกเลิก"
  icon="warning"
  confirmText="ยืนยัน"
  [isProcessing]="isSubmittingApproval"
  (confirmed)="onConfirmSubmitApproval()"
  (cancelled)="onCancelSubmitApproval()"
></app-confirm-dialog>

<app-confirm-dialog
  #submitApprovalSuccessDialog
  modalId="subjectManagementDetailsSubmitApprovalSuccessDialog"
  title="ส่งขอรับรองสำเร็จ"
  [message]="submitApprovalSuccessMessage"
  icon="success"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="submitApprovalSuccessDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #submitApprovalErrorDialog
  modalId="subjectManagementDetailsSubmitApprovalErrorDialog"
  title="ไม่สามารถส่งขอรับรองได้"
  [message]="submitApprovalErrorMessage"
  icon="warning"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="submitApprovalErrorDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #deleteItemWarningDialog
  modalId="subjectManagementDetailsDeleteItemWarningDialog"
  title="ยืนยันการลบรายการ"
  [message]="pendingDeleteMessage"
  cancelText="ยกเลิก"
  confirmText="ลบ"
  icon="trash"
  [stackAboveModal]="true"
  (confirmed)="onConfirmPendingDelete()"
  (cancelled)="onCancelPendingDelete()"
></app-confirm-dialog>

<app-confirm-dialog
  #saveSectionBeforeManageTeachersConfirmDialog
  modalId="subjectManagementDetailsSaveSectionBeforeManageTeachersConfirmDialog"
  title="ยืนยันการบันทึก Section"
  message="ต้องบันทึก Section นี้ก่อน จึงจะสามารถจัดการผู้สอนได้ ต้องการบันทึกเลยหรือไม่ ?"
  cancelText="ยกเลิก"
  icon="warning"
  confirmText="บันทึก"
  [isProcessing]="isSavingNewSection"
  (confirmed)="onConfirmSaveSectionBeforeManageTeachers()"
  (cancelled)="onCancelSaveSectionBeforeManageTeachers()"
></app-confirm-dialog>

<app-teacher-management-modal
  [teacherModalForm]="teacherModalForm"
  [teacherDraftRows]="teacherDraftRows"
  [teacherOptions]="teacherOptions"
  [teacherTeachingRangeOptions]="teacherTeachingRangeOptions"
  [errorMessage]="teacherModalErrorMessage"
  [editableTeacherRows]="getTeacherDraftRowEditability()"
  [workloadModeEditable]="!shouldDisableWorkloadModeChange()"
  [teachingTimes]="getActiveTeacherTeachingTimes()"
  [workloadHoursText]="activeTeacherSection === null ? '-' : activeTeacherSection.workloadHours"
  (addTeacher)="onAddTeacherDraftRow()"
  (removeTeacher)="onRemoveTeacherDraftRow($event)"
  (teacherSelected)="onTeacherSelected($event.rowIndex, $event.teacher)"
  (saveTeachers)="onSaveTeachers()"
  (cancelTeachers)="onCancelTeachers()"
></app-teacher-management-modal>

<app-project-teacher-modal
  [projectTeacherForm]="projectTeacherForm"
  [projectTeachingTimes]="projectTeachingTimes"
  [teacherOptions]="teacherOptions"
  [teachingDayOptions]="teachingDayOptions"
  [timeOptions]="timeOptions"
  [projectTeacherSubmitted]="projectTeacherSubmitted"
  (projectTeacherSelected)="onProjectTeacherSelected($event)"
  (addTeachingTime)="onAddProjectTeachingTime()"
  (removeTeachingTime)="onRemoveProjectTeachingTime($event)"
  (teachingTimeChanged)="updateProjectWorkloadHours()"
  (saveProjectTeacher)="onSaveProjectTeacher()"
  (cancelProjectTeacher)="onCancelProjectTeacher()"
></app-project-teacher-modal>
